import { Descriptions } from "antd";
import React from "react";
import { knownAllergiesOptions } from "../../../../IpEMR/Options/historyOptions";
import {
  getLabelTagsWithDescription,
  getLabelTagsWithDynamicInputs,
} from "../../../../IpEMR/InspectionSummaries/constructTextFromValues";

const KnownAllergies = ({ data }) => {
  return (
    <div>
      <Descriptions bordered={false}>
        <Descriptions.Item>
          {data && (
            <>
              {getLabelTagsWithDescription(knownAllergiesOptions, data)}
              {/* "Others" is captured as a dynamic remarks list, so it has to
                  be rendered alongside the checkbox labels. */}
              {getLabelTagsWithDynamicInputs(data?.known_allergies_others)}
            </>
          )}
        </Descriptions.Item>
      </Descriptions>
    </div>
  );
};

export default KnownAllergies;
